export var QuickBooksMappingEntityType;
(function (QuickBooksMappingEntityType) {
    QuickBooksMappingEntityType["Campaign"] = "campaign";
    QuickBooksMappingEntityType["Fund"] = "fund";
    QuickBooksMappingEntityType["AdditionalDonations"] = "additional_donations";
})(QuickBooksMappingEntityType || (QuickBooksMappingEntityType = {}));
